import * as ambassadorWixPlatformV1Wishlist from './platform-v1-wishlist-wishlist.http.js';
import * as ambassadorWixPlatformV1WishlistTypes from './platform-v1-wishlist-wishlist.types.js';
import * as ambassadorWixPlatformV1WishlistUniversalTypes from './platform-v1-wishlist-wishlist.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getWishlistById(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPlatformV1WishlistUniversalTypes.GetWishlistByIdRequest,
  ambassadorWixPlatformV1WishlistTypes.GetWishlistByIdRequest,
  ambassadorWixPlatformV1WishlistUniversalTypes.GetWishlistByIdResponse,
  ambassadorWixPlatformV1WishlistTypes.GetWishlistByIdResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPlatformV1Wishlist.getWishlistById(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wishlists/get',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  WishlistData as WishlistDataOriginal,
  WishlistItem as WishlistItemOriginal,
  ItemsAddedToWishlist as ItemsAddedToWishlistOriginal,
  ItemsRemovedFromWishlist as ItemsRemovedFromWishlistOriginal,
  GetWishlistRequest as GetWishlistRequestOriginal,
  WishlistItemKind as WishlistItemKindOriginal,
  GetWishlistResponse as GetWishlistResponseOriginal,
  AddToWishlistRequest as AddToWishlistRequestOriginal,
  AddToWishlistResponse as AddToWishlistResponseOriginal,
  RemoveFromWishlistRequest as RemoveFromWishlistRequestOriginal,
  RemoveFromWishlistResponse as RemoveFromWishlistResponseOriginal,
  GetWishlistByIdRequest as GetWishlistByIdRequestOriginal,
  GetWishlistByIdResponse as GetWishlistByIdResponseOriginal,
  GetWishlistsRequest as GetWishlistsRequestOriginal,
  GetWishlistsResponse as GetWishlistsResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './platform-v1-wishlist-wishlist.types.js';
